module.exports = __webpack_public_path__ + "img/labs.b7a95526.svg";